import { render } from "./contentCreatePersonModalMobile.vue?vue&type=template&id=7df3c3f6&scoped=true"
import script from "./contentCreatePersonModalMobile.vue?vue&type=script&lang=js"
export * from "./contentCreatePersonModalMobile.vue?vue&type=script&lang=js"

import "./contentCreatePersonModalMobile.vue?vue&type=style&index=0&id=7df3c3f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df3c3f6"]])

export default __exports__